import { useFeature } from '@pcln/feature-components'

import useSeti from '@/hooks/useSeti'

export const VACATION_VIBE_ENTRY_EXPERIMENT = 'PKG_SEARCH_FORM_VACATION_VIBE_GENAI_ENTRY'

type UseVacationVibeEntryParams = {
  pageName: 'homepage' | 'landing'
  isMobile: boolean
  /** The packages form records exposure. Sibling footers pass false so they only read the variant. */
  shouldFireImpression?: boolean
}

/** Homepage (any device) and package-landing desktop. Landing mweb stays out. */
function isVacationVibeEntryInScope({ pageName, isMobile }: UseVacationVibeEntryParams) {
  return pageName === 'homepage' || !isMobile
}

export function useVacationVibeEntry({
  pageName,
  isMobile,
  shouldFireImpression,
}: UseVacationVibeEntryParams) {
  const inScope = isVacationVibeEntryInScope({ pageName, isMobile })
  const variant = useSeti({
    experimentCode: VACATION_VIBE_ENTRY_EXPERIMENT,
    shouldFireImpression: shouldFireImpression ?? inScope,
  })
  // Default on: a missing packages store must not hide the banner the experiment already shows.
  const bannerEnabled = useFeature('pkgSearch.vacationVibeBannerEnabled', true) === true

  return inScope && variant === 'VARIANT' && bannerEnabled
}
